import React, { useEffect } from 'react';
import { IonSpinner, IonContent, IonPage } from '@ionic/react';
import { SplashScreen } from '@capacitor/splash-screen';
import { useMaintenanceModeCheck } from '../hooks/useMaintenanceModeCheck';
import useDelayedLoadingState from '../hooks/useDelayedLoadingState';
import MaintenancePage from '../pages/maintenance/MaintenancePage';

const HealthCheck = ({ children }) => {
  const { isMaintenanceMode, isChecking, retryCheck } = useMaintenanceModeCheck();
  const delayedIsChecking = useDelayedLoadingState(isChecking);

  useEffect(() => {
    if (isMaintenanceMode) {
      const hideSplashScreen = async () => {
        await SplashScreen.hide();
      };
      hideSplashScreen();
    }
  }, [isMaintenanceMode]);

  if (isMaintenanceMode) {
    return <MaintenancePage onRetry={retryCheck} isRetrying={isChecking} />;
  }

  if (delayedIsChecking) {
    return (
      <IonPage>
        <IonContent className="ion-padding">
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <IonSpinner name="crescent" />
          </div>
        </IonContent>
      </IonPage>
    );
  }

  if (!isChecking && !isMaintenanceMode) {
    return children;
  }

  return null;
};

export default HealthCheck;
